import getSearchParams from '../../utils/url/getSearchParams';
/**
 * @param {Location} location
 * @param {import('core/EcrionProvider/types').EcrionProviderRoutesConfig['publicLinks']} publicLinks
 */

export default (function (location, publicLinks) {
  if (!publicLinks) return null;
  if (!publicLinks.rules) return null;
  if (!publicLinks.rules.length) return null;
  var publicId = null;
  var searchParams = getSearchParams(location);
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = publicLinks.rules[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var rule = _step.value;

      if (typeof searchParams[rule.query] !== 'undefined') {
        publicId = searchParams[rule.query];
        break;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return publicId;
});